<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.33203 6.66675L7.9987 9.33341L10.6654 6.66675" stroke="#2A3243" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
